import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from './snackbarAction';
import { logOut } from './loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function examHallResponse(response) {
  return {
    type: types.EXAM_HALL_LIST_RESPONSE,
    response
  };
}

export const examHallRequest = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/exam/list';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(examHallResponse(data));
    });
};

export function examHallPlayerResponse(response) {
  return {
    type: types.EXAM_HALL_PLAYER_RESPONSE,
    response
  };
}
export const examHallPlayerRequest = async (
  loginData,
  PaperCode,
  TestCode,
  dispatch
) => {
  const jwtToken = loginData;
  const body = {
    PaperCode,
    TestCode
  };
  const url = 'api/exam/attempt';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(examHallPlayerResponse(data));
      return data;
    });
};
